/**
 * Function that resizes uploaded logos to a fixed pixel width/height
 * in order to reduce image size for faster upload speeds, and to ensure
 * that each image fits within the 5MB limit for images passed to the logos endpoint.
 * @param {canvas} canvas Canvas containing the image to be resized.
 * @param {number} MAX_WIDTH Max width of resized image in pixels.
 * @param {number} MAX_HEIGHT Max height of resized image in pixels.
 * @returns {canvas} the resized canvas of calculated pixel width/height.
 */

export const resizeImage = (canvas, MAX_WIDTH = 1176, MAX_HEIGHT = 600) => {
    const ratio = canvas.width / canvas.height;

    const newCanvas = document.createElement('canvas');
    const ctx = newCanvas.getContext('2d');

    // calculate width and height of resized image
    newCanvas.width =
        ratio * MAX_HEIGHT > MAX_WIDTH ? MAX_WIDTH : ratio * MAX_HEIGHT;
    newCanvas.height =
        ratio * MAX_HEIGHT > MAX_WIDTH ? MAX_WIDTH / ratio : MAX_HEIGHT;

    // draw image on new canvas and return data url
    ctx.drawImage(canvas, 0, 0, newCanvas.width, newCanvas.height);
    return newCanvas;
};
